import { motion } from 'framer-motion';
import React, { useState } from 'react';
import { Play, X, Youtube, Instagram } from 'lucide-react';
import { AnimatePresence } from 'framer-motion';

type VideoItem = {
  id: string;
  title: string;
  client?: string;
  type: 'youtube' | 'instagram' | 'local';
  url: string;
  thumbnail?: string;
  description?: string;
};

const VideosAndReels: React.FC = () => {
  const [selectedVideo, setSelectedVideo] = useState<VideoItem | null>(null);

  // Sample video data - replace with your actual videos
  const videos: VideoItem[] = [
    {
      id: '1',
      title: 'Cheap Materials vs Quality Materials',
      client: 'Virat Design Construction',
      type: 'youtube',
      url: 'https://www.youtube.com/embed/H_HFFAGhjQI', // Replace with actual YouTube video ID
      thumbnail: '/videos/virat.jpeg',
      description: 'Explains the true difference between cheap and quality materials.'
    },
    {
      id: '2',
      title: 'Get Ready for a Delicious Garba Night!',
      client: 'Saish Caterers',
      type: 'youtube',
      url: 'https://www.youtube.com/embed/snH-ny-O_HE', // Replace with actual YouTube video ID
      thumbnail: '/videos/saish-caterers.jpeg',
      description: 'Saish Caterers are here to make your Garba night unforgettable with something delicious!'
    },
    {
      id: '3',
      title: 'The Artists with Their Masterpieces',
      client: 'The Ashoka Hotel',
      type: 'youtube',
      url: 'https://www.youtube.com/embed/f5-ixZ8MxnY', // Replace with actual YouTube video ID
      thumbnail: '/videos/ashoka-hotel.jpeg',
      description: 'The Ashoka Hotel presents amazing artists and their unique creations.'
    },
    // {
    //   id: '4',
    //   title: 'Dental Implant',
    //   client: 'Advance Dental Care',
    //   type: 'youtube',
    //   url: 'https://www.youtube.com/embed/mX8Hm7_E-_U', // Replace with actual Instagram Reel URL
    //   thumbnail: '/videos/advance-dental.jpeg',
    //   description: 'Dr. Atul Bhat explains that dental implant treatment is a safe, comfortable procedure — and not painful, as many people believe'
    // },
    {
      id: '5',
      title: 'Plot Offers at Redwood Platinum',
      client: 'Shree Vinayakam Realties',
      type: 'youtube',
      url: 'https://www.youtube.com/embed/Z1noeZra4TQ', // Replace with actual YouTube video ID
      thumbnail: '/videos/shree-vinayakam.jpeg',
      description: 'Shree Vinayakam Realties showcases exclusive plot offers at Redwood Platinum, Indore Road.'
    },
    {
      id: '6',
      title: 'Urfi Javed’s Swelling',
      client: 'Dr. Manjeet Bhatia',
      type: 'youtube',
      url: 'https://www.youtube.com/embed/g53qRg5GOZc', // Replace with actual YouTube video ID
      thumbnail: '/videos/bhatia.jpeg',
      description: 'Dr. Manjeet Bhatia explains the case of Urfi Javed swelling under the eyes and lips wasn’t just because of fillers.and clarifies the real reasons behind it.'
    },
    {
      id: '7',
      title: 'Why Cavities Form',
      client: 'Dr. Vishakha Singh',
      type: 'youtube',
      url: 'https://www.youtube.com/embed/gQ0ObpvnOqU', // Replace with actual Instagram Reel URL
      thumbnail: '/videos/advance-dental.jpeg',
      description: 'Dr. Vishakha Singh  explains why cavities form, how advanced treatments can fix them, and shares a few tips to keep your teeth healthy.',
    },
    {
      id: '8',
      title: 'Basic Needs of Indories',
      client: 'The Ashoka Hotel',
      type: 'youtube',
      url: 'https://www.youtube.com/embed/t53xBI0jttw', // Replace with actual YouTube video ID
      thumbnail: '/videos/ashoka-hotel.jpeg',
      description: 'Shows the essential needs of Indories: oxygen, water, and more.'
    },
    {
      id: '9',
      title: 'Aligners vs Braces',
      client: 'Dr. Prateek Bhatia',
      type: 'youtube',
      url: 'https://www.youtube.com/embed/2OAn8FsDQr0', // Replace with actual YouTube video ID
      thumbnail: '/videos/bhatia.jpeg',
      description: 'Dr. Prateek Bhatia explains the difference between aligners vs braces, how each works, and which one might be suitable for you.'
    },
    {
      id: '10',
      title: 'The Aroma Of Celebration Awaits You!',
      client: 'Saish Caterers',
      type: 'youtube',
      url: 'https://www.youtube.com/embed/FGfRyEn11qg', // Replace with actual YouTube video ID
      thumbnail: '/videos/saish-caterers.jpeg',
      description: 'Saish Caterers showcase their full event setup — from stunning decorations to complete preparations.'
    },
    {
      id: '11',
      title: 'Your Own Plot at a Rau Prime Location',
      client: 'Shree Vinayakam Realties',
      type: 'youtube',
      url: 'https://www.youtube.com/embed/xy38bCfbN_A', // Replace with actual YouTube video ID
      thumbnail: '/videos/shree-vinayakam.jpeg',
      description: 'Shree Vinayakam Realties brings you your own plot at a rau prime location. Discover all the exciting features and offers!'
    },
    {
      id: '12',
      title: 'How a Home Can Look',
      client: 'Virat Design Construction',
      type: 'youtube',
      url: 'https://www.youtube.com/embed/-FJQCtzt-Lw', // Replace with actual YouTube video ID
      thumbnail: '/videos/virat.jpeg',
      description: 'Shares photos of the house from the outside, showcasing its style and structure.'
    },
    {
      id: '13',
      title: 'Slip Disc',
      client: 'Dr. Saurabh Tiwari',
      type: 'youtube',
      url: 'https://www.youtube.com/embed/ItTb2HRRgtI', // Replace with actual YouTube video ID
      thumbnail: '/videos/pain-relief-clinic.jpeg',
      description: 'Dr. Saurabh explains why a slip disc happens, how it causes back and waist pain, and how advanced therapy can relieve it effectively.'
    },
    {
      id: '14',
      title: 'Your pain doesn’t need surgery to get better.',
      client: 'Dr. Saurabh Tiwari',
      type: 'youtube',
      url: 'https://www.youtube.com/embed/h08b9ZcTvfQ', // Replace with actual YouTube video ID
      thumbnail: '/videos/pain-relief-clinic.jpeg',
      description: 'Dr. Saurabh Tiwari explains how we provide effective, non-operative relief.'
    },
  ];

  const getEmbedUrl = (video: VideoItem): string => {
    if (video.type === 'youtube') {
      // Extract video ID from YouTube URL
      const videoId = video.url.includes('embed/') 
        ? video.url.split('embed/')[1].split('?')[0]
        : video.url.split('v=')[1]?.split('&')[0] || video.url;
      return `https://www.youtube.com/embed/${videoId}`;
    }
    if (video.type === 'instagram') {
      // Instagram Reel embed
      const reelId = video.url.split('/reel/')[1]?.split('/')[0] || '';
      return `https://www.instagram.com/reel/${reelId}/embed/`;
    }
    return video.url;
  };

  const getVideoIcon = (type: string) => {
    switch (type) {
      case 'youtube':
        return <Youtube className="w-6 h-6" />;
      case 'instagram':
        return <Instagram className="w-6 h-6" />;
      default:
        return <Play className="w-6 h-6" />;
    }
  };

  return (
    <div className="pt-20 overflow-x-hidden">
      {/* Hero Section */}
      <section className="py-24 bg-gradient-to-br from-primary-50 to-accent-50 overflow-x-hidden">
        <div className="container-custom">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            className="text-center max-w-4xl mx-auto"
          >
            <h1 className="text-5xl md:text-6xl font-serif font-bold mb-6">
              Video & <span className="text-gradient">Reels</span>
            </h1>
            <p className="text-xl text-neutral-600 leading-relaxed">
              Explore our collection of engaging video content, reels, and motion graphics that bring brands to life and captivate audiences.
            </p>
          </motion.div>
        </div>
      </section>

      {/* Videos Grid */}
      <section className="py-24 bg-white">
        <div className="container-custom">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {videos.map((video, index) => (
              <motion.div
                key={video.id}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: index * 0.1 }}
                viewport={{ once: false }}
                className="group cursor-pointer"
                onClick={() => setSelectedVideo(video)}
              >
                <div className="bg-white rounded-xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300">
                  {/* Thumbnail */}
                  <div className="relative aspect-video bg-neutral-100 overflow-hidden">
                    {video.thumbnail ? (
                      <img
                        src={video.thumbnail}
                        alt={video.title}
                        className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                        onError={(e) => {
                          const target = e.target as HTMLImageElement;
                          target.style.display = 'none';
                        }}
                      />
                    ) : (
                      <div className="w-full h-full bg-gradient-to-br from-primary-400 to-accent-400 flex items-center justify-center">
                        {getVideoIcon(video.type)}
                      </div>
                    )}
                    
                    {/* Play Overlay */}
                    <div className="absolute inset-0 bg-black/40 group-hover:bg-black/50 transition-all duration-300 flex items-center justify-center">
                      <div className="w-16 h-16 bg-white/90 rounded-full flex items-center justify-center group-hover:scale-110 transition-transform duration-300">
                        <Play className="w-8 h-8 text-primary-600 ml-1" fill="currentColor" />
                      </div>
                    </div>

                    {/* Video Type Badge */}
                    <div className="absolute top-4 right-4">
                      <div className="bg-white/90 backdrop-blur-sm rounded-full p-2 shadow-lg">
                        {getVideoIcon(video.type)}
                      </div>
                    </div>
                  </div>

                  {/* Content */}
                  <div className="p-6">
                    {video.client && (
                      <div className="text-sm text-primary-600 font-medium mb-2">
                        {video.client}
                      </div>
                    )}
                    <h3 className="text-xl font-bold text-neutral-900 mb-2 group-hover:text-primary-600 transition-colors duration-300">
                      {video.title}
                    </h3>
                    {video.description && (
                      <p className="text-neutral-600 text-sm line-clamp-2">
                        {video.description}
                      </p>
                    )}
                  </div>
                </div>
              </motion.div>
            ))}
          </div>

          {/* Empty State */}
          {videos.length === 0 && (
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              className="text-center py-24"
            >
              <div className="w-24 h-24 bg-primary-100 rounded-full flex items-center justify-center mx-auto mb-6">
                <Play className="w-12 h-12 text-primary-600" />
              </div>
              <h3 className="text-2xl font-bold text-neutral-900 mb-4">No Videos Yet</h3>
              <p className="text-neutral-600 max-w-md mx-auto">
                We're working on adding amazing video content. Check back soon!
              </p>
            </motion.div>
          )}
        </div>
      </section>

      {/* Video Modal */}
      <AnimatePresence>
        {selectedVideo && (
          <>
            {/* Backdrop */}
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              className="fixed inset-0 bg-black/80 z-[9999] flex items-center justify-center p-4"
              onClick={() => setSelectedVideo(null)}
            >
              {/* Modal Content */}
              <motion.div
                initial={{ opacity: 0, scale: 0.9 }}
                animate={{ opacity: 1, scale: 1 }}
                exit={{ opacity: 0, scale: 0.9 }}
                transition={{ duration: 0.3 }}
                className="relative w-full max-w-4xl bg-white rounded-2xl overflow-hidden shadow-2xl"
                onClick={(e) => e.stopPropagation()}
              >
                {/* Close Button */}
                <button
                  onClick={() => setSelectedVideo(null)}
                  className="absolute top-4 right-4 z-10 w-10 h-10 bg-white/90 backdrop-blur-sm rounded-full flex items-center justify-center hover:bg-white transition-colors duration-200 shadow-lg"
                >
                  <X className="w-6 h-6 text-neutral-900" />
                </button>

                {/* Video Embed */}
                <div className="aspect-video bg-neutral-900">
                  {selectedVideo.type === 'youtube' || selectedVideo.type === 'instagram' ? (
                    <iframe
                      src={getEmbedUrl(selectedVideo)}
                      className="w-full h-full"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                      allowFullScreen
                      title={selectedVideo.title}
                    />
                  ) : (
                    <video
                      src={selectedVideo.url}
                      controls
                      className="w-full h-full"
                      autoPlay
                    >
                      Your browser does not support the video tag.
                    </video>
                  )}
                </div>

                {/* Video Info */}
                {/* <div className="p-6">
                  {selectedVideo.client && (
                    <div className="text-sm text-primary-600 font-medium mb-2">
                      {selectedVideo.client}
                    </div>
                  )}
                  <h3 className="text-2xl font-bold text-neutral-900 mb-3">
                    {selectedVideo.title}
                  </h3>
                  {selectedVideo.description && (
                    <p className="text-neutral-600">
                      {selectedVideo.description}
                    </p>
                  )}
                </div> */}
              </motion.div>
            </motion.div>
          </>
        )}
      </AnimatePresence>
    </div>
  );
};

export default VideosAndReels;

